module.exports = __webpack_public_path__ + "img/xbtd.51aa87af.png";